/**
 * Returns values in data array that meet all the filter conditions
 * The targetValue of each filter condition must equal the data value at the key corresponding to category
 * If range is specified, the data value must fall between the first and second elements in the range array
 * @param {Array} data
 * @param {{category: String, targetValue?: Any, range?: Array}[]} filterConditions
 */
function applyFilters(data, filterConditions) {
  return data
    .filter((item) => {
      return filterConditions.reduce((prevResult, currentEl) => {
        const currentVal = item[currentEl.category];
        if (currentEl.targetValue !== undefined) {
          return prevResult && currentVal === currentEl.targetValue;
        }
        if (currentEl.range) {
          return prevResult && currentVal >= currentEl.range[0] && currentVal <= currentEl.range[1];
        }
        return prevResult;
      }, true);
    });
}

export default applyFilters;